import { OrgChartNode } from "components";
import { useAppDispatch, useAppSelector } from "stores";

import { orgChartSlice } from "./reducers";

export const useOrgChartHook = () => {
  const dispatch = useAppDispatch();
  const orgChart = useAppSelector((state) => state?.orgChart.orgChart);
  const nodeSelected = useAppSelector((state) => state?.orgChart.nodeSelected);

  const setOrgChart = (newOrgChart: OrgChartNode[]) => {
    dispatch(orgChartSlice.actions.setOrgChart(newOrgChart));
  };

  const setNodeSelected = (node: OrgChartNode) => {
    dispatch(orgChartSlice.actions.setNodeSelected(node));
  };

  const addNode = (parentId: number, node: OrgChartNode) => {
    dispatch(orgChartSlice.actions.addNode({ parentId, node }));
  };

  const updateNode = (node: OrgChartNode) => {
    dispatch(orgChartSlice.actions.updateNode({ node }));
  };

  const addEmployees = (
    parentId: number,
    employees: OrgChartNode["employees"]
  ) => {
    dispatch(orgChartSlice.actions.addEmployees({ parentId, employees }));
  };

  const deleteDeptManager = (
    nodeId: number,
    managerId: number,
    role: string
  ) => {
    dispatch(
      orgChartSlice.actions.deleteDeptManager({ nodeId, managerId, role })
    );
  };

  const deleteDept = (nodeId: number) => {
    dispatch(orgChartSlice.actions.deleteDept({ nodeId }));
  };

  const addDeptManager = (
    parentId: number,
    deptManagers: OrgChartNode["deptManagers"]
  ) => {
    dispatch(orgChartSlice.actions.addDeptManager({ parentId, deptManagers }));
  };

  const reset = () => {
    dispatch(orgChartSlice.actions.reset());
  };

  return {
    orgChart,
    nodeSelected,

    setOrgChart,
    setNodeSelected,
    addNode,
    updateNode,
    addEmployees,
    deleteDeptManager,
    deleteDept,
    addDeptManager,
    reset,
  };
};
